// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-button[data-v-26ec04f7]{margin:0;padding:0;background:transparent;background-color:transparent;border:none;outline:none;text-decoration:none;flex-grow:1;margin:0 10px;padding:5px 10px;min-width:50px;background:#3700b3;background-color:#3700b3;color:hsla(0,0%,100%,.87);box-shadow:2px 2px 3px rgba(0,0,0,.2)}.fr-button[data-v-26ec04f7]:hover{cursor:pointer}.fr-button[data-v-26ec04f7]:first-child{margin-left:0}.fr-button[data-v-26ec04f7]:last-child{margin-right:0}", ""]);
// Exports
module.exports = exports;
